import styled from 'styled-components';

const QuestionRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${(props) => props.theme.spacing(6)};
`;

export default QuestionRow;
